import { Flex, Icon, Text } from '@chakra-ui/react';
import type { ComponentProps } from 'react';
import React from 'react';

type MobileNavbarItemProps = ComponentProps<typeof Flex> & {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
};

const MobileNavbarItem = ({ icon, label, onClick, ...rest }: MobileNavbarItemProps) => {
  return (
    <Flex
      as="button"
      height="63px"
      flexDirection="column"
      width="20%"
      gap={1}
      alignItems="center"
      justifyContent="center"
      role="button"
      aria-label={label}
      onClick={onClick}
      backgroundColor="transparent"
      border="none"
      {...rest}
    >
      <Icon color="neutral.30" aria-hidden="true">
        {icon}
      </Icon>
      <Text textStyle="caption2" color="neutral.50">
        {label}
      </Text>
    </Flex>
  );
};

export default MobileNavbarItem;
